import ClickOut from "./click-out";

export default (Vue) => {
  Vue.directive("click-out", ClickOut);
};
